import { render, staticRenderFns } from "./CountryChar.vue?vue&type=template&id=514c7cb0&scoped=true"
import script from "./CountryChar.vue?vue&type=script&lang=js"
export * from "./CountryChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c7cb0",
  null
  
)

export default component.exports